import * as React from "react";

function IcPolicyCheck16(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 16,
    height = 16,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcPolicyCheck16"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M11 14H4.23453C3.04251 14 2.11513 12.9639 2.24676 11.7791L3 5M11 14H12C13.1046 14 14 13.1046 14 12V10H11.6667M11 14L11.6667 10M3 5H1.5V4C1.5 2.89543 2.39543 2 3.5 2H12M3 5H10V4.8541C10 3.71779 10.642 2.679 11.6584 2.17082L12 2M12 2V2C12.5235 2 12.9217 2.47004 12.8356 2.98639L11.6667 10"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 8.5L7 11L11.5 6.5"
        stroke={accent}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default IcPolicyCheck16;
